import { post } from 'app/utils/axios/kheti'
import { SOWING_RECORD_TYPE } from '../models/crop'

interface Response {
  detail: string
  sowing_record_id: string
}

const createSowingRecord = async (
  farmerId: string,
  cropId: string,
  sowingDate: string,
  type: SOWING_RECORD_TYPE,
) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/sowing-record`
    return await post<Response>(url, {
      crop_id: cropId,
      sowing_date: sowingDate,
      type,
    })
  } catch (e) {
    return null
  }
}

export default createSowingRecord
